import React from 'react';
import {NavLink} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';

import {PrimaryButton} from 'Components/Button';
import {ModalTrigger} from 'Components/Modal';

import {isAdminPage, roundedElements} from 'Services/BaseHelpers';

export default class ActionsButton extends React.Component {
    /**
     * @var state
     * @type {{show: boolean}}
     */
    state = {
        show: false,
    };

    /**
     * @constructor
     */
    constructor(props) {
        super(props);

        this.dropdownRef = React.createRef();
        this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this);
    }

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        const {layout = 'dropdown'} = this.props;

        if (layout === 'dropdown') {
            document.addEventListener("mousedown", this.handleClickOutsideDropdown);
        }
    }

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount() {
        const {layout = 'dropdown'} = this.props;

        if (layout === 'dropdown') {
            document.removeEventListener("mousedown", this.handleClickOutsideDropdown);
        }
    }

    /**
     * Close the dropdown whenever click outside of it.
     *
     * @method handleClickOutsideDropdown
     * @param {event} event
     */
    handleClickOutsideDropdown(event) {
        if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
            this.setState({
                show: false
            });
        }
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {buttons, layout = 'dropdown'} = this.props;
        const {show} = this.state;

        if (!buttons) {
            return null;
        }

        if (layout === 'dropdown') {
            return (
                <div ref={this.dropdownRef}>
                    <div
                        className={`
                            ${isAdminPage() ? 'bg-blue-700 text-white' : 'bg-app-primary text-app-primary-contrast'}
                            ${roundedElements() ? 'rounded-xl ' : ''}
                            px-3 py-2 shadow-lg cursor-pointer select-none
                        `}
                        onClick={() => this.setState({show: !show})}
                        title="Click for more actions..."
                    >
                        <FontAwesomeIcon icon={show ? faCaretUp : faCaretDown}/>
                    </div>

                    <div className={`
                        ${isAdminPage() ? 'bg-blue-700 text-white' : 'bg-app-primary text-app-primary-contrast'}
                        ${roundedElements() ? 'rounded-xl ' : ''}
                        absolute mt-2 shadow-lg z-20 text-left
                        py-1 ring-1 ring-black ring-opacity-5
                        ${show ? '' : 'hidden'}
                    `}>
                        {buttons.map((button, i) => this.renderButton(button, i))}
                    </div>
                </div>
            );
        }

        if (layout === 'row') {
            return (
                <div className="flex flex-row justify-center items-center gap-2 select-none">
                    {buttons.map((button, i) => this.renderButton(button, i))}
                </div>
            );
        }

        if (layout === 'column') {
            return (
                <div className="flex flex-col justify-center items-stretch gap-2 select-none">
                    {buttons.map((button, i) => this.renderButton(button, i))}
                </div>
            );
        }
    }

    /**
     * @method renderButton
     * @param {object} button
     * @param {integer} i
     * @return {JSX.Element}
     */
    renderButton(button, i) {
        const {layout = 'dropdown'} = this.props;

        if (layout == 'dropdown') {
            var styles = 'block py-2 px-4 font-medium hover:bg-gray-100 leading-5 text-white hover:text-black cursor-pointer';
        } else if (layout === 'row' || layout === 'column') {
            // Borrowed style from PrimaryButton.
            var styles = `
                ${isAdminPage() ?
                    'bg-blue-700 text-white hover:bg-light-blue-800 focus:ring-light-blue-500' :
                    'bg-app-primary text-app-primary-contrast hover:bg-app-primary-hover focus:ring-app-primary-focus'}
                ${roundedElements() ? 'rounded-xl ' : ''}
                border border-transparent shadow-sm py-2 px-4 inline-flex
                justify-center items-center text-sm font-medium
                focus:outline-none focus:ring-2 focus:ring-offset-2
                cursor-pointer w-full
            `;
        }

        let content = button.text;

        if (button.icon) {
            content = <FontAwesomeIcon icon={button.icon} title={button.title ?? null} />;
        }

        if (button.type === "link") {
            return (
                <NavLink to={button.to} className={styles} target={button.target} key={i}>
                    {content}
                </NavLink>
            );
        } else if (button.type === "href") {
            return (
                <a href={button.to} target={button.target} key={i}>
                    <div className={styles}>
                        {content}
                    </div>
                </a>
            );
        } else if (button.type === "onClick") {
            return (
                <div onClick={button.onClick} className={styles} key={i}>
                    {content}
                </div>
            );
        } else if (button.type === "modalTrigger") {
            return (
                <ModalTrigger
                    component={button.component}
                    props={button.props}
                    key={i}
                >
                    <div className={styles}>
                        {content}
                    </div>
                </ModalTrigger>
            );
        }
    }
}
